import {
  classifySocialUrl,
  isExplicitHandleMarker,
  isHandleFormat,
  HANDLE_FORMAT_REGEX,
  SOCIAL_HANDLE_MIN_LENGTH,
} from "root/modules/@snap/reports/helpers/identify-report-type.helpers";
import type { SocialNetwork } from "~/types/global";

// Fonte única dos primitivos de handle vive no módulo @snap/reports (raiz de
// dependência), reexportada aqui para os consumidores do domínio ReportInput.
export { SOCIAL_HANDLE_MIN_LENGTH, HANDLE_FORMAT_REGEX };

export type SocialInputShape = "url" | "explicit-handle" | "bare-handle";

export type SocialInputClassification =
  | {
    matched: true;
    shape: SocialInputShape;
    confidence: "high" | "medium";
    network: SocialNetwork | null;
  }
  | {
    matched: false;
    reason: "insufficient-length";
    shape: "bare-handle";
  }
  | {
    matched: false;
    reason: "not-social";
  };

/**
 * Classificador único de entradas de redes sociais, compartilhado entre a
 * detecção em tempo real e a validação de criação de relatório. Opera sobre a
 * string já com `trim()` e nunca lança.
 */
export class SocialInputClassifier {
  static classify(trimmed: string): SocialInputClassification {
    const url = classifySocialUrl(trimmed);
    if (url.isValid) {
      return {
        matched: true,
        shape: "url",
        confidence: "high",
        network: url.network,
      };
    }

    if (this.isExplicitHandleMarker(trimmed)) {
      return {
        matched: true,
        shape: "explicit-handle",
        confidence: "medium",
        network: null,
      };
    }

    if (!trimmed.includes("@") && this.isHandleFormat(trimmed) && !/^\d+$/.test(trimmed)) {
      if (trimmed.length >= SOCIAL_HANDLE_MIN_LENGTH) {
        return {
          matched: true,
          shape: "bare-handle",
          confidence: "medium",
          network: null,
        };
      }
      return { matched: false, reason: "insufficient-length", shape: "bare-handle" };
    }

    return { matched: false, reason: "not-social" };
  }

  static isHandleFormat(candidate: string): boolean {
    return isHandleFormat(candidate);
  }

  static isExplicitHandleMarker(trimmed: string): boolean {
    return isExplicitHandleMarker(trimmed);
  }
}
